/* eslint-disable @next/next/no-img-element -- official multicolor Google G
   from public/icons/social (real brand mark, colors baked into the SVG),
   same rule as SocialFollowRow. */
import { PreferredSourceLink } from "@/components/chrome/preferred-source-link"

/**
 * PreferOnGoogleChip — a visible "add us as a preferred source on Google
 * Search" button for content surfaces (FRIDGE-581, owner 08/27/2026: this used
 * to be prominent on articles and must be again — "def blog and everything
 * else"; home/about-class pages stay clean).
 *
 * The destination is Google's own preferred-sources flow
 * (https://developers.google.com/search/docs/appearance/preferred-sources) —
 * a reader who adds Fridge.com sees more of our coverage in their Top
 * Stories. The tiny G in the footer's SocialFollowRow opens the same flow
 * sitewide; this chip is the in-content mount. One control,
 * PreferredSourceLink — never a second copy. It invokes Google's official Preferred Sources SDK
 * instead of navigating the reader away (FRIDGE-876, owner 09/05/2026).
 *
 * Icon per the owner's icon spec: the full official multicolor G, no chip
 * box around the logo itself, always colorful.
 */
export function PreferOnGoogleChip({ className = "" }: { className?: string }) {
  return (
    <PreferredSourceLink
      className={`flex w-full min-h-14 items-center justify-center gap-3 rounded-xl border-2 border-[#0469f0] bg-white px-4 py-3 text-[15px] font-semibold text-gray-900 hover:border-[#ff9951] transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#ff9951] focus-visible:ring-offset-1 ${className}`}
    >
      <img src="/icons/social/google.svg" alt="" aria-hidden width={18} height={18} className="shrink-0" />
      <span>
        Add Fridge.com as a <span>preferred source on Google</span>
      </span>
    </PreferredSourceLink>
  )
}
